/**
 * Pedido de teste do onboarding do painel (docs/requisito-onboarding-painel-v1.md, seção 10.3): o dono abre a
 * própria loja pelo link `?teste=<token>`. O token vale para a aba (sessionStorage) e vai junto na leitura da
 * empresa (a loja aparece aberta) e no pedido (passa com a loja fechada e fica marcado como teste).
 */
const CHAVE = 'meucardapio.pedidoTesteOnboarding';
const FORMATO = /^[a-f0-9]{24}$/;

export function tokenPedidoTesteOnboarding(): string | null {
  try {
    const daUrl = new URLSearchParams(window.location.search).get('teste');
    if (daUrl && FORMATO.test(daUrl)) {
      sessionStorage.setItem(CHAVE, daUrl);
      return daUrl;
    }
    const salvo = sessionStorage.getItem(CHAVE);
    return salvo && FORMATO.test(salvo) ? salvo : null;
  } catch (e) {
    return null;
  }
}
